import { render, staticRenderFns } from "./AuditHistoryEntity.vue?vue&type=template&id=05060e08&scoped=true"
import script from "./AuditHistoryEntity.vue?vue&type=script&lang=js"
export * from "./AuditHistoryEntity.vue?vue&type=script&lang=js"
import style0 from "./AuditHistoryEntity.vue?vue&type=style&index=0&id=05060e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05060e08",
  null
  
)

export default component.exports